import { Button, Modal } from "@dreambigger/design-system";
import { Space } from "antd";
import { memo } from "react";

type Props = {
  visible: boolean;
  okText: string;
  onOk: Function;
  cancelText: string;
  onCancel: Function;
  recipientCount: number;
  note: string;
  closable?: boolean;
};

/**
 * A warning modal to display to the user for thank you notes or invite notes
 * notifying them that they are about to send {recipientCount} amount of notes.
 */
const NoteWarningModal = ({
  visible,
  okText,
  onOk,
  cancelText,
  onCancel,
  recipientCount,
  note,
  closable = true,
}: Props) => {
  const handleCancel = () => {
    onCancel();
  };

  const handleOk = () => {
    onOk();
  };

  return (
    <Modal
      open={visible}
      closable={closable}
      onOk={handleOk}
      okText={okText}
      onCancel={handleCancel}
      cancelText={cancelText}
      footer={null}
    >
      <div className="tc f-8">📬</div>
      <p className="fwb md_f-5 tc">
        Are you sure you want to send your {note} to{" "}
        <span className="red-1 underline">{recipientCount}</span> people?
      </p>
      <p className="md_f-4 tc">
        If not, select cancel below and adjust your recipient list. If you are
        ready to send, then select send!
      </p>
      <div className="tc">
        <Space>
          {/* CANCEL BUTTON */}
          <Button onClick={handleCancel} className="ttu md_h-7 min-w-11">
            {cancelText}
          </Button>

          {/* OK BUTTON */}
          <Button
            onClick={handleOk}
            className="b-primary ttu md_h-7 lightenPrimaryBkd min-w-11"
            type="primary"
          >
            {okText}
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default memo(NoteWarningModal);
